import React, { useEffect, useState } from 'react';
import { Typography, Select, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import dayjs from 'dayjs';
import { useDirectHoursStatus } from '@features/activities/hooks/useActivityQueries';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

const useStyles = makeStyles((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginLeft: '1em',
    marginRight: '2em',
  },
  icon: {
    marginRight: '0.5em',
    verticalAlign: 'middle',
  },
  hourLocal: {
    verticalAlign: 'middle',
    paddingRight: '24px',
  },
  hour: {
    verticalAlign: 'middle',
  },
  selectInactiveItem: {
    color: theme.palette.common.white,
    fontSize: '16px',
  },
  selectActiveItem: {
    color: theme.palette.secondary.main,
    fontSize: '16px',
  },
  iconSelect: {
    fill: theme.palette.common.white,
  },
}));

export const TimzezoneHourSelect = (props) => {
  const { activeHourSelected, setActiveHourSelected } = props;
  const [parisHour, setParisHour] = useState(dayjs().tz('Europe/Paris').format('DD/MM/YYYY HH:mm'));
  const [localHour, setLocalHour] = useState(dayjs().format('DD/MM/YYYY HH:mm'));
  const [guyaneHour, setGuyaneHour] = useState(dayjs().tz('America/Cayenne').format('DD/MM/YYYY HH:mm'));
  const [antilleHour, setAntilleHour] = useState(dayjs().tz('America/Martinique').format('DD/MM/YYYY HH:mm'));
  const [reunionHour, setReunionHour] = useState(dayjs().tz('Indian/Reunion').format('DD/MM/YYYY HH:mm'));
  const [mayotteHour, setMayotteHour] = useState(dayjs().tz('Indian/Mayotte').format('DD/MM/YYYY HH:mm'));
  const classes = useStyles();

  const { data: directHoursStatus } = useDirectHoursStatus();

  useEffect(() => {
    if (directHoursStatus) {
      setActiveHourSelected(directHoursStatus.isWithinDirectHours);
    }
  }, [directHoursStatus, setActiveHourSelected]);

  useEffect(() => {
    const interval = setInterval(() => {
      setParisHour(dayjs().tz('Europe/Paris').format('DD/MM/YYYY HH:mm'));
      setLocalHour(dayjs().format('DD/MM/YYYY HH:mm'));
      setGuyaneHour(dayjs().tz('America/Cayenne').format('DD/MM/YYYY HH:mm'));
      setAntilleHour(dayjs().tz('America/Martinique').format('DD/MM/YYYY HH:mm'));
      setReunionHour(dayjs().tz('Indian/Reunion').format('DD/MM/YYYY HH:mm'));
      setMayotteHour(dayjs().tz('Indian/Mayotte').format('DD/MM/YYYY HH:mm'));
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classes.column}>
      <Typography variant="subtitle1" className={classes.hourLocal}>
        Local : {localHour}
      </Typography>

      <Typography variant="subtitle1" className={classes.hour}>
        <Select
          id="timezoneHourSelect"
          defaultValue="Europe/Paris"
          className={activeHourSelected ? classes.selectActiveItem : classes.selectInactiveItem}
          inputProps={{
            classes: {
              icon: classes.iconSelect,
            },
          }}
          onChange={() => {}}
        >
          <MenuItem key={4} value={'America/Martinique'}>
            Antilles : {antilleHour}
          </MenuItem>
          <MenuItem key={5} value={'America/Cayenne'} name={guyaneHour}>
            Guyane : {guyaneHour}
          </MenuItem>
          <MenuItem key={1} value={'Europe/Paris'} name={parisHour}>
            Métropole : {parisHour}
          </MenuItem>
          <MenuItem key={3} value={'Indian/Mayotte'} name={mayotteHour}>
            Mayotte : {mayotteHour}
          </MenuItem>
          <MenuItem key={2} value={'Indian/Reunion'} name={reunionHour}>
            Réunion : {reunionHour}
          </MenuItem>
        </Select>
      </Typography>
    </div>
  );
};
